import React, { useEffect, useState } from "react";
import { Button } from "../Button/Button";
interface Props {
  buttons: any[];
}

export default ({ buttons }: Props) => {
  return (
    <>
      {buttons.map((button, index) => {
        if (button.message.length > 0)
          return (
            <Button
            key = {index}
              message={button.message}
              icon={button.icon}
              onClick={button.onClick}
              disabled={button.disabled}
            />
          );
      })}
    </>
  );
};
